import { render, staticRenderFns } from "./model_list.vue?vue&type=template&id=07c2842a&scoped=true"
import script from "./model_list.vue?vue&type=script&lang=ts"
export * from "./model_list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2842a",
  null
  
)

export default component.exports